// ===== POC Cuidados Paliativos (PNCP) - atualização periódica =====
// A equipe assistencial e a matricial trabalham em telas diferentes. Este mixin
// chama o método indicado da tela a cada 20 s (com a aba visível), para ela
// recarregar da API o que a outra equipe mudou.
//
// Uso: mixins: [pocLiveSync("reload")]

const INTERVAL_MS = 20000;

export function pocLiveSync(methodName) {
  return {
    mounted() {
      this.pocLiveSyncTimer = setInterval(() => {
        if (document.visibilityState === "visible") this[methodName]();
      }, INTERVAL_MS);
    },
    beforeUnmount() {
      clearInterval(this.pocLiveSyncTimer);
    }
  };
}
